'use client';

import { MimaText } from '@/components';
import React from 'react';
import styles from '@/assets/styles/pages/competition/competition.module.scss';

interface CompetitionsProps {
  competitionList: any;
}

interface HtmlContentProps {
  content: string;
}

const LearnMore: React.FC<CompetitionsProps> = ({ competitionList }) => {
  const currentCompetition = competitionList?.filter((item: any) => item?.status === 'ACTIVE').map((competition: any) => competition)?.[0];
  const HtmlContent: React.FC<HtmlContentProps> = ({ content }) => {
    return <div dangerouslySetInnerHTML={{ __html: content }} />;
  };

  return (
    <section className={styles.learnMore} id="learnMore">
      <MimaText variant="h3" align="center" mt={2} mb={2}>
        {currentCompetition?.subTitle}
      </MimaText>
      <HtmlContent content={currentCompetition?.description} />

      <div>
        <MimaText variant="h2" align="center" className={styles.titleText}>
          PRIZES
        </MimaText>

        {currentCompetition?.prizes.map((prize: any) => {
          return (
            <div className={styles.prizeCard} key={prize.prize}>
              <div className={styles.prizeCardTitle}>
                <MimaText variant="h4">{prize?.title}</MimaText>
              </div>
              <div className={styles.prizeList}>
                <div>
                  <ul>
                    <li>{prize?.prizeKey1}</li>
                    <li>{prize?.prizeKey2}</li>
                    <li>{prize?.prizeKey3}</li>
                  </ul>
                </div>

                <div>
                  <ul>
                    <li>{prize?.prizeValue1}</li>
                    <li>{prize?.prizeValue2}</li>
                    <li>{prize?.prizeValue3}</li>
                  </ul>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default LearnMore;
